import React from 'react';

export function FullNameColumnFormatter(cellContent) {

  return (
      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
      {cellContent.firstName}  {cellContent.lastName}
      </span>
  );
}
